<template>
  <a-layout class='s_bf'>
      <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="{span:6}" :wrapper-col="{span:14,offset:1}" >
        <a-form-item ref="tag_name" required label="标签名" name="tag_name" :wrapper-col="{span:10,offset:1}" >
          <a-input v-model:value="form.tag_name" placeholder="请输入标签名称" :disabled="type=='look'"/>
        </a-form-item>
        <div class="s_bf7 p-t-10 p-b-10">
          <a-form-item ref="" label="设置打标签"  name="" >
            <div class="">
              <div class="s_flex_ali">
                <a-checkbox v-model:checked="form.is_point"></a-checkbox>
                <p class="width-120 m-l-5">累计积分达到</p>
              </div>
              <div class="s_flex_ali m-t-10" v-show="form.is_point">
                <a-input-number style="width:67%" v-model:value="form.point" :precision='0' :min='0' type="number" placeholder="请输入累计积分" :disabled="type=='look'"></a-input-number>
                <a-tooltip placement='right'>
                  <template #title>该用户历史累计获得积分（不包含系统退回）等于或大于设置的数值。
                  </template>
                  <QuestionCircleOutlined style="color: #195b78;margin-left: 10px;" />
                </a-tooltip>
              </div>
            </div>
            <!--  -->
            <div class="m-t-20">
              <div class="s_flex_ali">
                <a-checkbox v-model:checked="form.is_buy"></a-checkbox>
                <p class="width-120 m-l-5">累计购买次数达到</p>
              </div>
              <div class="s_flex_ali m-t-10" v-show="form.is_buy">
                <a-input-number style="width:67%" v-model:value="form.buy_num" :precision='0' :min='0' type="number" placeholder="请输入累计购买次数" :disabled="type=='look'"></a-input-number>
                <a-tooltip placement='right'>
                  <template #title>消费者在云店支付成功的累计次数大于或等于设置的值。
                  </template>
                  <QuestionCircleOutlined style="color: #195b78;margin-left: 10px;" />
                </a-tooltip>
              </div>
            </div>
             <!--  -->
            <div class="m-t-20">
              <div class="s_flex_ali">
                <a-checkbox v-model:checked="form.is_money"></a-checkbox>
                <p class="width-120 m-l-5">累计消费金额达到</p>
              </div>
              <div class="s_flex_ali m-t-10" v-show="form.is_money">
                <a-input-number style="width:67%" v-model:value="form.buy_money" :precision='0' :min='0' type="number" placeholder="请输入累计消费金额" :disabled="type=='look'"></a-input-number>
                <a-tooltip placement='right'>
                  <template #title>消费者在云店支付成功的累计付款金额大于或等于设置的值。
                  </template>
                  <QuestionCircleOutlined style="color: #195b78;margin-left: 10px;" />
                </a-tooltip>
              </div>
            </div>
            <div class="m-t-20">
              <div class="s_flex_ali">
                <a-checkbox v-model:checked="form.is_scan"></a-checkbox>
                <p class="width-120 m-l-5">累计首次扫码数</p>
              </div>
              <div class="s_flex_ali m-t-10" v-show="form.is_scan">
                <a-input-number style="width:67%" v-model:value="form.first_scan" :precision='0' :min='0' type="number" placeholder="请输入累计首次扫码数" :disabled="type=='look'"></a-input-number>
                <a-tooltip placement='right'>
                  <template #title>消费者累计首次扫码数大于或等于设置的值。
                  </template>
                  <QuestionCircleOutlined style="color: #195b78;margin-left: 10px;" />
                </a-tooltip>
              </div>
            </div>
            <div class="m-t-20">
              <div class="s_flex_ali">
                <a-checkbox v-model:checked="form.is_category" ></a-checkbox>
                <p class="width-120 m-l-5">根据产品分类</p>
              </div>
              <div class="s_flex_ali m-t-10" v-show="form.is_category">
                <a-select v-model:value="form.category" style="width:67%" placeholder="请选择" :disabled="type=='look'">
                  <a-select-option :value="item.id" v-for="item in categoryOption" :key="item.id">{{item.name}}</a-select-option>
                </a-select>
                <a-tooltip placement='right'>
                  <template #title>消费者在云店支付成功订单的商品一级分类等于设置的值。
                  </template>
                  <QuestionCircleOutlined style="color: #195b78;margin-left: 10px;" />
                </a-tooltip>
              </div>
            </div>

            <div class="m-t-20">
              <div class="s_flex_ali">
                <a-checkbox v-model:checked="form.is_price"></a-checkbox>
                <p class="width-120 m-l-5">根据产品价格区间</p>
              </div>
              <div class="s_flex_ali m-t-10" v-show="form.is_price">
                 <div  class="s_flex_ali " style="width:67%">
                   <a-input style="width:50%" v-model:value="form.price_min" :precision='0' :min='0' placeholder="最小值" v-inputFilter:price :disabled="type=='look'"></a-input>
                  <div style="height:2px;width:40px;background:#999" class="m-l-5 m-r-5"></div>
                   <a-input style="width:50%" v-model:value="form.price_max" :precision='0' :min='form.price_min' placeholder="最大值" v-inputFilter:price :disabled="type=='look'"></a-input>
                 </div>
                <a-tooltip placement='right'>
                  <template #title>消费者在云店或者扫码场景产生关联的产品价格满足设置的价格区间。
                  </template>
                  <QuestionCircleOutlined style="color: #195b78;margin-left: 10px;" />
                </a-tooltip>
              </div>
            </div>
            <div class="m-t-20 s_fonts12 s_c999">
              <div>1、商户可自行打标签，可填写一个条件及多个条件。</div>
              <div class="m-t-5">2、打标签过程中，满足任一条件即可完成打标签操作。</div>
            </div>
          </a-form-item>
        </div>
        <a-form-item ref="id" hidden>
          <a-input v-model:value="form.id" />
        </a-form-item>
        <a-form-item class='m-t-25' :wrapper-col="{ span: 24, offset: 21 }">
          <a-button type="primary" @click="onSubmit" v-if="type!='look'">
            保存
          </a-button>
        </a-form-item>
      </a-form>
  </a-layout>
</template>
<script>
  import {  QuestionCircleOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, reactive, toRefs, inject } from 'vue';
  import { message } from 'ant-design-vue';
  import { iscode } from "@/utils/app";
  import { createMemberTag, editMemberTag,memberTag,getMemberTagInfo,postMemberTagInfo,memberTagCat  } from '@/api/member'
  // 初始化默认筛选项数值
  let defForm = {
    tag_name:'',
    point:'',
    buy_num:'',
    buy_money:'',
    scan_num:'',
    first_scan:'',
    category:null,
    price_min:'',
    price_max:'',
    price_range:'',
    is_point:false,
    is_buy:false,
    is_money:false,
    is_category:false,
    is_price:false,
    is_scan:false
  }
  export default {
    name: 'tagAdd',
    components: {QuestionCircleOutlined},
    props: {
      formData: {
        type: Object
      },
      type:{
        type:String
      }
    },
    setup(props, { emit }) {
      //pass
      const form = ref({ ...defForm });
      const state = reactive({
        labelCol: { span: 5 },
        wrapperCol: { span: 17 },
        formData:{},
        addressData:[],
        categoryOption:[]
      });
      const ruleForm = ref()

      const getTagInfo = async function(){
         const hide = message.loading('正在加载中...', 0);
          let res = await getMemberTagInfo(props.formData.id).then(res=>res.data)
          setTimeout(hide);
          if(iscode(res)){
            form.value = Object.assign(form.value,res.data,{
            is_buy:true,
            is_point:true,
            is_money:true,
            is_category:true,
            is_price:true,
            is_scan:true,
            price_min:res.data.price_range ? res.data.price_range.split('/')[0] : '',
            price_max:res.data.price_range ? res.data.price_range.split('/')[1] : ''
            });
          }
          
      }
      //编辑和添加
      const onSubmit =async function(){
           const hide = message.loading('正在加载中...', 0);
           let res;
           form.value.price_range = form.value.price_min + '/' + form.value.price_max
           if(props.type == 'add'){
              res = await memberTag({...form.value}).then(res=>res.data);
           }else{
              res = await postMemberTagInfo({...form.value}).then(res=>res.data);
           }
           setTimeout(hide);
           if(iscode(res)){
             message.success(res.msg)
              emit('openModal',false)
           }else{
              message.error(res.msg)
           }  
      }
    //产品分类
    const getMemberTagCat = async function(){
      let res = await memberTagCat().then(res=>res.data);
      if(iscode(res)){
         state.categoryOption = res.data || []
      }else{
         message.error(res.msg);
      }
    }



      onMounted(() => {
         getMemberTagCat()
        if(props.formData.id){
          form.value = props.formData
        }
        console.log(props.formData)
        if(props.type != 'add'){
           getTagInfo()
        }
       
      });
      return {
        form,
        ...toRefs(state),
        ruleForm,
        // submit,
        getTagInfo,
        onSubmit
      }
    }
  }
</script>
